// 书籍状态
export const BookStatus = [
  { label: "正常", value: 1, color: "success" },
  { label: "下架", value: 2, color: "error" },
];

// 图片状态
export const ImageStatus = [
  { label: "已完成", value: 1, color: "success" },
  { label: "未完成", value: 2, color: "processing" },
  { label: "解析失败", value: 3, color: "error" },
  { label: "其他错误", value: 4, color: "warning" },
];

// 笔记分类
export const NoteCategory = [
  { label: "精选助记", value: 1, color: "success" },
  { label: "用户笔记", value: 2, color: "processing" },
];

// 用户状态
 export const UserStatus = [
   { label: "正常", value: 1, color: "success" },
   { label: "禁用", value: 2, color: "error" },
   { label: "注销", value: 4, color: "warning", disabled: true },
 ];

 // 用户角色
export const UserRole = [
  { label: "管理员", value: 1, color: "processing" },
  { label: "客服", value: 30, color: "error" },
];

// 书籍来源
export const BookSource = [
  { label: "自营", value: 1, color: "processing" },
  { label: "用户", value: 2, color: "default" },
];

// 书籍类型
export const BookType = [
  { label: "通用书籍", value: 1, color: "processing" },
  { label: "拍书翻译", value: 2, color: "error" },
  { label: "拍物学词", value: 3, color: "success" },
];

// 注册渠道
export const RegisterChannel = [
  { label: "APP注册", value: "captcha" },
  { label: "考研英语词汇速记", value: "考研英语词汇速记" },
  { label: "线性代数辅导讲义", value: "线性代数辅导讲义" },
  { label: "高等数学辅导讲义", value: "高等数学辅导讲义" },
  { label: "四级真题解析", value: "四级真题解析" },
  { label: "六级真题解析", value: "六级真题解析" },
  { label: "听力练习", value: "听力练习" },
  { label: "分享赚钱", value: "分享赚钱" },
  { label: "金太阳", value: "金太阳" },
  { label: "27考研英语一真题速刷", value: "27考研英语一真题速刷" },
  { label: "27考研英语二真题速刷", value: "27考研英语二真题速刷" },
  { label: "27考研数学一真题速刷", value: "27考研数学一真题速刷" },
  { label: "27考研数学二真题速刷", value: "27考研数学二真题速刷" },
  { label: "27考研数学三真题速刷", value: "27考研数学三真题速刷" },
];

// 邀请等级
export const InviteLevel = [
  { label: "直接下级", value: 1, color: "processing" },
  { label: "间接下级", value: 2, color: "error" },
];

// 分佣状态
export const CommissionStatus = [
  { label: "待结", value: "PENDING", color: "processing" },
  { label: "已结", value: "SETTLED", color: "success" },
  { label: "已退", value: "CANCELLED", color: "error" },
];

// 绑定方式
export const BindType = [
  { label: "邀请注册", value: "REGISTER", color: "error" },
  { label: "后期补录", value: "MANUAL", color: "processing" },
];

// 年级配置
export const GradeConfig = [
  { label: "一年级", value: 11 },
  { label: "二年级", value: 12 },
  { label: "三年级", value: 13 },
  { label: "四年级", value: 14 },
  { label: "五年级", value: 15 },
  { label: "六年级", value: 16 },
  { label: "初一", value: 21 },
  { label: "初二", value: 22 },
  { label: "初三", value: 23 },
  { label: "初四", value: 24 },
  { label: "高一", value: 31 },
  { label: "高二", value: 32 },
  { label: "高三", value: 33 },
  { label: "大一", value: 41 },
  { label: "大二", value: 42 },
  { label: "大三", value: 43 },
  { label: "大四", value: 44 },
  { label: "大五", value: 45 },
  { label: "研究生", value: 51 },
];

// 书籍功能
export const BookFunction = [
  { label: "课文点读", value: "TEXT_POINT_READING" },
  { label: "课文翻译", value: "TEXT_TRANSLATION" },
  { label: "单词点读", value: "WORD_POINT_READING" },
  { label: "单词听写", value: "WORD_DICTATION" },
  { label: "闯关背词", value: "WORD_BREAKTHROUGH" },
  { label: "循环背词", value: "WORD_LOOP" },
  { label: "配套资料", value: "SUPPORTING_MATERIALS" },
  { label: "课文朗读", value: "TEXT_AUDIO_READING" },
  { label: "生词速检", value: "WORD_QUICK_CHECK" },
];

// 图书功能标记状态
export const BookFunctionStatus = [
  { label: "未标记", value: 1, color: "success" },
  { label: "已标记", value: 2, color: "error" },
];
